'use strict'
import urls from './Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  ADDRESS: 'address',
  MOBY_DTO: 'moby'
}

// Org Address
function getOrgAddressEndPoint () {
  return urls.memberOrgApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS
}

function getMobyDtoApiEndPoint () {
  return urls.memberOrgApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_DTO
}

function loadOrgAddress (orgId) {
  return axios.get(getOrgAddressEndPoint(), {
    params: {
      'orgId': orgId
    }
  })
}

function loadMobyDto (orgId, academicYear) {
  return axios.get(getMobyDtoApiEndPoint(), {
    params: {
      'orgId': orgId,
      'academicYear': academicYear
    }
  })
}

export default {
  loadOrgAddress: loadOrgAddress,
  loadMobyDto: loadMobyDto
}
